import { motion } from 'motion/react';
import { Text } from '@nula/core-ui';

import styles from '../app.module.css';

/**
 * Brief loader shown between successful sign-in and the first paint of the
 * full app shell. Renders in the 'workspace-pending' boot state — after auth
 * has resolved but before WorkspaceBootstrap has fetched /api/workspaces and
 * picked an active workspace.
 *
 * Visually mirrors the splash (ambient orbs) so the transition from splash →
 * sign-in → here → shell feels continuous instead of fragmented.
 */
export function WorkspaceSettingUp() {
  return (
    <motion.div
      key="workspace-setting-up"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className={styles.splash}
    >
      {/* Same ambient orbs as the splash so the visual continues. */}
      <motion.div
        animate={{ opacity: [0.3, 0.5, 0.3] }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
        className={styles.splashOrb}
        style={{ '--orb-size': '500px' } as React.CSSProperties}
      />
      <motion.div
        animate={{ opacity: [0.2, 0.4, 0.2] }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut', delay: 0.5 }}
        className={styles.splashOrb2}
        style={{ '--orb-size': '600px' } as React.CSSProperties}
      />

      <div className={styles.workspaceSetUpContent}>
        <Text type="secondary" className={styles.workspaceSetUpText}>
          Setting up your workspace…
        </Text>
      </div>
    </motion.div>
  );
}
